import { render, staticRenderFns } from "./ChangeUserName.vue?vue&type=template&id=4b1dc431&scoped=true"
import script from "./ChangeUserName.vue?vue&type=script&lang=js"
export * from "./ChangeUserName.vue?vue&type=script&lang=js"
import style0 from "./ChangeUserName.vue?vue&type=style&index=0&id=4b1dc431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1dc431",
  null
  
)

export default component.exports